module.exports = {
    "sections": [
        {
            "name": "Need and policy",
            "slug": "need-policy",
            "number": 1,

            "questions": [
                {
                    "label": "Do you have any suggestions as to how North Falls could work with Essex-based businesses to help them take advantage of potential contracting opportunities with the project?",
                    "number": "1",
                    "name": "01-question",
                    "response": "There were a number of suggestions as to how the project could work with local firms including regional supply chain engagement, registration portals and ensuring local knowledge is utilised for issues such as drainage and soil. Also working with local companies who have had previous offfshore wind experience via the likes of the Thanet and London Array projects. Finally ensuring  local land and property owners are in a position to benefit from potential work scopes  such as storage, contractor accommodation and  complimentary opportunities."
                }
            ]
        },
        {
            "name": "Site selection",
            "slug": "site-selection",
            "number": 2,

            "questions": [
                {
                    "label": "What outcome would you like from the Offshore Transmission Network Review?",
                    "number": "2",
                    "name": "02-question",
                    "response": "The majority of those who answered this question hoped to see an integrated offshore transmission network (a preference for North Falls' grid connection option 3), primarily to negate the need for substation(s) in Tendring, but also to potentially remove the need for the pylons related to the National Grid Norwich to Tilbury project. A number of responses referred to that project's pylons as a motivator for an offshore connection. There were also comments around use of brownfield sites and the need to accelerate to get the project to completion."
                }
            ]
        },
        {
            "name": "Project description",
            "slug": "project-description",
            "number": 3,

            "questions": [
                {
                    "label": "Do you have any comments about the landfall compound zone that could help us identify the best location for the temporary construction compound?",
                    "number": "3",
                    "name": "03-question",
                    "response": "A number of responses to this question reiterated the message that an offshore connection would be preferred, negating the need for landfall here. However there were a handful of specific comments and queries  related to the existing proposed location that the project will assess, for example around flooding, horse livery and local traffic. There was a suggestion to avoid the golf course as a site for the temporary construction compound (the cable will go underneath the golf course and it will not be used as a temporary construction compound) and also to work with local cycling groups."
                },
                {
                    "label": "Are there any areas of the onshore cable corridor you have specific information or comments about?",
                    "number": "4",
                    "name": "04-question",
                    "response": "Comments supplied to this question offered some useful insights, particularly related to the section around Thorpe-le-Spoken where there are varying constraints related to each option proposed currently. Some preferences for the northern route and some for the southern. These will be reviewed collectively to determine the most feasible way forward. Traffic volumes have been brought up as a concern,  around Thorpe-le-Soken and also Kirby Cross. There was also specific mention of Great Holland Mill and a common theme was land drainage."
                },
                {
                    "label": "Looking at the proposed onshore substation zone, is there anything North Falls should know that could help with the final siting of the electrical infrastructure?",
                    "number": "5",
                    "name": "05-question",
                    "response": "Other than further statements declaring a preference for an offshore grid connection, responses to this question ranged from requests to totally screen the substation from view by use of tall trees and vegetation, to ensuring all infrastructure (for example the National Grid and Five Estuaries substations)  be located closely together. There were also suggestions to move the substation further inland (so the Norwich Tilbury route carried on on a straight line), or further to the east."
                }
            ]
        },
        {
            "name": "Offshore",
            "slug": "offshore",
            "number": 4,

            "questions": [
                {
                    "label": "Do you have any comments about any of the offshore-related assessments or on the mitigation measures proposed?",
                    "number": "6",
                    "name": "06-question",
                    "response": "There were limited direct responses to this question however there were views that 1. there should be more offshore sites developed and 2. offshore wind farms should go elsewhere. There was general agreement the offshore environmental and maritime mitigation proposed appeared thorough however questions were posed around the work done to date on an offshore grid connection option."
                }
            ]
        },
        {
            "name": "Onshore",
            "slug": "onshore",
            "number": 5,

            "questions": [
                {
                    "label": "Do you have any comments about any of the onshore-related assessments or on the mitigation measures proposed?",
                    "number": "7",
                    "name": "07-question",
                    "response": "Responses to this question primarily focussed on people's concern related to potential additional traffic during construction due to already stretched local road networks. However there were also other specific issues brought up for example around: a cast iron-water main and request to have it replaced;  levels of compensation to be paid; access to existing recreational areas; and  impacts on  tourism. In terms of construction work on agricultural land, attention was drawn to the need for effective methodologies for storing and replacing soil, avoidance of weeds and invasive plants, and drainage schemes."
                }
            ]
        },
        {
            "name": "Project wide",
            "slug": "project-wide",
            "number": 6,

            "questions": [
                {
                    "label": "Are you supportive of the North Falls Offshore Wind Farm project?",
                    "number": "8",
                    "name": "08-question",

                    "options": [
                        {
                            "label": "Yes",
                            "value": "yes"
                        },
                        {
                            "label": "Yes (conditional on changes - please provide details below)",
                            "value": "yes-conditional"
                        },
                        {
                            "label": "No",
                            "value": "no"
                        },
                        {
                            "label": "Don't know",
                            "value": "dont-know"
                        }
                    ],
                    "response": "Of those who answered this question the vast majority (more than 80%) responded yes to this question.  A typical 'yes' response was: I'm very supportive of all projects which help to utilise more green sources of power and help the UK become more self-sufficient.   Around half of those who stated yes said the yes was conditional on changes, those changes primarily being with an offshore grid connection or if the onshore infrastructure was located elsewhere. Around 10% were not supportive and a similar number did not know if they were supportive or not due to the fact that they needed more details."
                }
            ]
        },
        {
            "name": "Other",
            "slug": "other",
            "number": 7,

            "questions": [
                {
                    "label": "Do you have any further comments to add?",
                    "number": "9",
                    "name": "09-question",
                    "response": "This question gave respondents the opportunity to add or reiterate points and so included a wide range of inputs. There were those wishing the project luck and urging the team to 'get on with it' and others taking the chance to further state their preference for an offshore grid connection. There was reference to the need for North Falls to continue to work closely with Five Estuaries; to potential community benefits, as well as specific questions on smaller scale wind turbine options, consultation with the elderly and landowner issues. All feedback form responses will be collated with the other consultation inputs received (emails, letters, postcards and via the website) and considered together as the proposals are further refined and matured."
                }
            ]
        }
    ]
};